var messageFiltersToSearchParams = function (messageFilters) {
    var searchParams = new URLSearchParams();
    for (var _i = 0, _a = Object.keys(messageFilters); _i < _a.length; _i++) {
        var filterKey = _a[_i];
        var filterValue = messageFilters[filterKey];
        if (filterValue) {
            if (Array.isArray(filterValue)) {
                for (var _b = 0, filterValue_1 = filterValue; _b < filterValue_1.length; _b++) {
                    var singleFilterValue = filterValue_1[_b];
                    searchParams.append(filterKey, singleFilterValue);
                }
            }
            else {
                searchParams.set(filterKey, filterValue.toString());
            }
        }
    }
    return searchParams;
};
export default messageFiltersToSearchParams;
